module.exports = __webpack_public_path__ + "img/puberty-decal-02.c4971a4a.png";